import React, { useState, useEffect } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";

import { Multiselect } from "multiselect-react-dropdown";
import category from "../../../services/node-category/category";
import LoadingSpinner from "../../../shared/Spinner/LoadingSpinner";
import { refetchApi } from '../../../shared/utils';
import { successToast } from "../../../shared/notification";

function AddCategory({ closeAddCategory }) {
	const [categoryList, setCategoryList] = useState([]);
	const [newCatName, setNewCatName] = useState("");
	const [nodeList, setNodeList] = useState([]);
	const [selectedNodeList, setSelectedNodeList] = useState([]);
	const [selectedCategory, setSelectedCategory] = useState({});

	const [mainSelectedNodeList, setMainSelectedNodeList] = useState([]);
	const [mainDeselectedNodeList, setMainDeselectedNodeList] = useState([]);

	const [modalAddCat, setModalAddCat] = useState(false);
	const toggleAddCat = () => setModalAddCat(!modalAddCat);

	const [modalEditCat, setModalEditCat] = useState(false);
	const toggleEditCat = () => setModalEditCat(!modalEditCat);

	const [modalAddNode, setAddNode] = useState(false);
	const toggleAddNode = () => setAddNode(!modalAddNode);

	const [loading, setLoading] = useState(true);

	let newEntry = false;

	useEffect(() => {
		setLoading(true);
		category
			.getInstance()
			.getCategory()
			.then((result) => {
				setCategoryList(result);
				setLoading(false);
			});
	}, []);

	function onAddCategory(e) {
		e.preventDefault();

		let dataToSubmit = {
			category:  newCatName,
		};
		setLoading(true);
		category
			.getInstance()
			.addCategory(dataToSubmit)
			.then((result) => {
				// setCategoryList((categoryList) => [
				// 	...categoryList,
				// 	{ category: newCatName },
				// ]);
				successToast(result["message"]);
				window.location.reload();
				setLoading(false);
			});
	}

	function onDeleteCategory(item) {
		let dataToSubmit = {
			id: item.id,
		};

		setLoading(true);
		category
			.getInstance()
			.deleteCategory(dataToSubmit)
			.then((result) => {
				successToast(result["message"]);
				if (result["success"]) {
					window.location.reload();
				}
				setLoading(false);
			});
	}

	function onEditCategory(e) {
		e.preventDefault();
		console.log(selectedCategory, newCatName)
		let dataToSubmit = {
			id: selectedCategory.id,
			category: newCatName,
		};

		setLoading(true);
		category
			.getInstance()
			.updateCategory(dataToSubmit)
			.then((result) => {
				successToast(result["message"]);
				window.location.reload();
				setLoading(false);
			});
	}

	function onUpdateNode() {
		setLoading(true);

		for (let index = 0; index < mainSelectedNodeList.length; index++) {
			mainSelectedNodeList[index]["username"] = localStorage.getItem("cloudatik");
			mainSelectedNodeList[index]["sensor_set"] = mainSelectedNodeList[index]["node"].split("-")[1];
			mainSelectedNodeList[index]["category"] = selectedCategory.category;
		}
		for (let index = 0; index < mainDeselectedNodeList.length; index++) {
			mainDeselectedNodeList[index]["username"] =
				localStorage.getItem("cloudatik");
			mainDeselectedNodeList[index]["sensor_set"] =
				mainDeselectedNodeList[index]["node"].split("-")[1];
		}

		let dataToSubmit = {
			selected: mainSelectedNodeList,
			deselected: mainDeselectedNodeList,
		};

		category
			.getInstance()
			.updateCategoryNode(dataToSubmit)
			.then((result) => {
				successToast(result["message"]);
				window.location.reload();
				setLoading(false);
			});
	}

	function onOpenEditModal(item) {
		setModalEditCat(true);
		setSelectedCategory(item)
	}

	function onOpenAddNodeModal(item) {
		setLoading(true);
		setAddNode(true);
		setSelectedCategory(item);
		fetch(
			`${process.env.REACT_APP_API_URL
			}/getUserNodeCategoryV2/`, {
			headers: {
				'Authorization': localStorage.getItem('cloudatik-access')
			}
		}
		)
			.then((res) => res.json())
			.then(
				(result) => {
					if (result.code && result.code === 'token_not_valid') {
						refetchApi();
					}

					let nodeWithCategory = [];
					let selectedNode = [];
					let allNode = [];
					let allNodeWithCategory = [];
					setNodeList([]);
					setSelectedNodeList([]);
					for (let index = 0; index < result["group"].length; index++) {
						nodeWithCategory.push({
							node: `${result["group"][index]["serial"]}-${result["group"][index]["sensor_set"] == null
								? 1
								: result["group"][index]["sensor_set"]
								}`,
							category: result["group"][index]["category"],
						});

						if (result["group"][index]["category"] == item.category) {
							selectedNode.push(
								`${result["group"][index]["serial"]}-${result["group"][index]["sensor_set"] == null
									? 1
									: result["group"][index]["sensor_set"]
								}`
							);
						}
					}

					for (let index = 0; index < result["node"].length; index++) {
						let node_id = `${result["node"][index]["serial"]}-${result["node"][index]["sensor_set"] == null
							? 1
							: result["node"][index]["sensor_set"]
							}`;
						allNode.push({
							node: node_id,
							device_id: result["node"][index]["device_id"],
							display_name: result["node"][index]["tag_name"] + ' [' + node_id + ']',
						});
					}

					for (let x = 0; x < allNode.length; x++) {
						let a = 0;
						for (let index = 0; index < nodeWithCategory.length; index++) {
							if (nodeWithCategory[index]["node"] == allNode[x]["node"]) {
								allNodeWithCategory.push({
									id: x,
									node: nodeWithCategory[index]["node"],
									category: nodeWithCategory[index]["category"],
									device_id: allNode[x]["device_id"],
									display_name: allNode[x]["display_name"]
								});
								a = 1;
							}
						}
						if (a == 0) {
							allNodeWithCategory.push({
								id: x,
								node: allNode[x]["node"],
								category: null,
								device_id: allNode[x]["device_id"],
								display_name: allNode[x]["display_name"]
							});
						}
					}

					for (let index = 0; index < allNodeWithCategory.length; index++) {
						setNodeList((nodeList) => [
							...nodeList,
							allNodeWithCategory[index],
						]);

						if (allNodeWithCategory[index]["category"] == item.category) {
							newEntry = true;
							setSelectedNodeList((selectedNodeList) => [
								...selectedNodeList,
								allNodeWithCategory[index],
							]);
						}
					}
					setLoading(false);
				},
				(error) => {
					console.log(error);
				}
			);
	}

	function onSelect(selectedList, selectedItem) {
		setMainSelectedNodeList(selectedList);
	}

	function onRemove(selectedList, removedItem) {
		setMainDeselectedNodeList((mainDeselectedNodeList) => [
			...mainDeselectedNodeList,
			removedItem,
		]);
	}

	return (
		<div>
			{loading && <LoadingSpinner />}
			<Modal isOpen={modalAddNode} toggle={toggleAddNode} className={"sm"} size="lg">
				<form>
					<ModalHeader toggle={toggleAddNode}>Edit Node</ModalHeader>
					<ModalBody>
						<div className="container">
							<Multiselect
								options={nodeList} // Options to display in the dropdown
								selectedValues={selectedNodeList} // Preselected value to persist in dropdown
								onSelect={onSelect} // Function will trigger on select event
								onRemove={onRemove} // Function will trigger on remove event
								displayValue="display_name" // Property name to display in the dropdown options
							/>
						</div>
					</ModalBody>
					<ModalFooter>
						<button className="btn btn-info" onClick={onUpdateNode}>
							Save Node
						</button>
						<Button color="secondary" onClick={toggleAddNode}>
							Cancel
						</Button>
					</ModalFooter>
				</form>
			</Modal>

			<Modal isOpen={modalEditCat} toggle={toggleEditCat} className={"sm"} size="lg">
				<form onSubmit={onEditCategory}>
					<ModalHeader toggle={toggleEditCat}>Edit Category Name</ModalHeader>
					<ModalBody>
						<div className="container">
							<div className="row">
								{/* <div className="col">
									<div className="form-group">
										<label for="txt_category">Old Category Name</label>
										<input
											type="text"
											className="form-control"
											id="txt_category"
											value={oldCatName}
											onChange={(e) => setOldCatName(e.target.value)}
											required
										/>
										<small id="txt_category" className="form-text text-muted">
											Proper Category.
										</small>
									</div>
								</div> */}
								<div className="col">
									<div className="form-group">
										<label for="txt_new_category">New Category Name</label>
										<input
											type="text"
											className="form-control"
											id="txt_new_category"
											value={newCatName}
											onChange={(e) => setNewCatName(e.target.value)}
											required
										/>
										<small id="txt_category" className="form-text text-muted">
											Proper Category.
										</small>
									</div>
								</div>
							</div>
						</div>
					</ModalBody>
					<ModalFooter>
						<button type="submit" className="btn btn-info">
							Update Category
						</button>
						<Button color="secondary" onClick={toggleEditCat}>
							Cancel
						</Button>
					</ModalFooter>
				</form>
			</Modal>

			<Modal isOpen={modalAddCat} toggle={toggleAddCat} className={"sm"} size="lg">
				<form onSubmit={onAddCategory}>
					<ModalHeader toggle={toggleAddCat}>Add Category</ModalHeader>
					<ModalBody>
						<div className="container">
							<div className="row">
								<div className="col">
									<div className="form-group">
										<label for="txt_category">Category Name</label>
										<input
											type="text"
											className="form-control"
											id="txt_category"
											value={newCatName}
											onChange={(e) => setNewCatName(e.target.value)}
											required
										/>
										<small id="txt_category" className="form-text text-muted">
											Proper Category.
										</small>
									</div>
								</div>
							</div>
						</div>
					</ModalBody>
					<ModalFooter>
						<button type="submit" className="btn btn-info">
							Add Category
						</button>
						<Button color="secondary" onClick={toggleAddCat}>
							Cancel
						</Button>
					</ModalFooter>
				</form>
			</Modal>

			<Modal isOpen={true} toggle={closeAddCategory} className={"sm"} size="lg">
				<ModalHeader toggle={closeAddCategory}>Category</ModalHeader>
				<ModalBody sx={{width: '1650px'}} >
					<div className="container" >
						<div className="row">
							<div className="col">
								<table className="table table-bordered table-hover text-nowrap">
									<thead>
										<tr>
											<th width="70%">Category</th>
											<th style={{textAlign:'center'}}>Action</th>
										</tr>
									</thead>
									<tbody>
									{categoryList.map((item) => (
										<tr>
											<td>{item.category}</td>
											<td style={{textAlign:'center'}}>
												<a title="Add Category" className="btn btn-tool" onClick={() =>onOpenAddNodeModal(item)}>
													<AddIcon/>
												</a>
												<a title="Edit Category" className="btn btn-tool" onClick={() => onOpenEditModal(item)}>
													<EditIcon/>
												</a> 
												<a title="Remove Category" className="btn btn-tool" onClick={() => onDeleteCategory(item)}>
													<DeleteIcon/>
												</a>
											</td>
										</tr>
									))}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</ModalBody>
				<ModalFooter>
					<button className="btn btn-info"
						onClick={() => setModalAddCat(true)}>
						Add
					</button>
					<Button color="secondary" onClick={closeAddCategory}>
						Close
					</Button>
				</ModalFooter>
			</Modal>
		</div>
	);
}

export default AddCategory;
